const KK = {
  months: [
    {
      short: 'Қаң',
      full: 'Қаңтар',
    },
    {
      short: 'Ақп',
      full: 'Ақпан',
    },
    {
      short: 'Нау',
      full: 'Наурыз',
    },
    {
      short: 'Сәу',
      full: 'Сәуір',
    },
    {
      short: 'Мам',
      full: 'Мамыр',
    },
    {
      short: 'Мау',
      full: 'Маусым',
    },
    {
      short: 'Шіл',
      full: 'Шілде',
    },
    {
      short: 'Там',
      full: 'Тамыз',
    },
    {
      short: 'Қыр',
      full: 'Қыркүйек',
    },
    {
      short: 'Қаз',
      full: 'Қазан',
    },
    {
      short: 'Қар',
      full: 'Қараша',
    },
    {
      short: 'Жел',
      full: 'Желтоқсан',
    },
  ],
  days: [
    {
      short: 'Дс',
      full: 'Дүйсенбі',
    },
    {
      short: 'Сс',
      full: 'Сейсенбі',
    },
    {
      short: 'Ср',
      full: 'Сәрсенбі',
    },
    {
      short: 'Бс',
      full: 'Бейсенбі',
    },
    {
      short: 'Жм',
      full: 'Жұма',
    },
    {
      short: 'Сб',
      full: 'Сенбі',
    },
    {
      short: 'Жс',
      full: 'Жексенбі',
    },
  ],
};

const RU = {
  months: [
    {
      short: 'Янв',
      full: 'Январь',
    },
    {
      short: 'Фев',
      full: 'Февраль',
    },
    {
      short: 'Мар',
      full: 'Март',
    },
    {
      short: 'Апр',
      full: 'Апрель',
    },
    {
      short: 'Май',
      full: 'Май',
    },
    {
      short: 'Июн',
      full: 'Июнь',
    },
    {
      short: 'Июл',
      full: 'Июль',
    },
    {
      short: 'Авг',
      full: 'Август',
    },
    {
      short: 'Сен',
      full: 'Сентябрь',
    },
    {
      short: 'Окт',
      full: 'Октябрь',
    },
    {
      short: 'Ноя',
      full: 'Ноябрь',
    },
    {
      short: 'Дек',
      full: 'Декабрь',
    },
  ],
  days: [
    {
      short: 'Пн',
      full: 'Понедельник',
    },
    {
      short: 'Вт',
      full: 'Вторник',
    },
    {
      short: 'Ср',
      full: 'Среда',
    },
    {
      short: 'Чт',
      full: 'Четверг',
    },
    {
      short: 'Пт',
      full: 'Пятница',
    },
    {
      short: 'Сб',
      full: 'Суббота',
    },
    {
      short: 'Вс',
      full: 'Воскресенье',
    },
  ],
};

export const datePickerLocales = { RU, KK };
